<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="10">
            <a-form-item label="项目编号">
              <a-input placeholder="请输入项目编号" v-model="queryParam.projNum"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.projectName"/>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="10">
              <a-form-item label="客户名称">
                <j-search-select-tag type="list" v-model="queryParam.customer" 
                  dict="biz_customer,name,id" 
                  :async = "true"
                  placeholder="请输入至少两个汉字查询"/>
              </a-form-item>
            </a-col>
            <a-col :md="2" :sm="6">
              <a-form-item label="包含下级">
                <a-checkbox v-model="queryParam.includeSubCustomer">
                </a-checkbox>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="6">
              <a-form-item label="项目类型">
                <j-dict-select-tag
                  placeholder="请选择项目类型"
                  v-model="queryParam.type"
                  dictCode="bms_project_type">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            
            <a-col :md="6" :sm="8">
              <a-form-item label="创建日期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.createTimeRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('项目档案表')" v-has="'archivesManagementList:export'">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)" v-has="'archivesManagementList:detail'">详情</a>
          <!--<a-divider type="vertical"/>-->
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'archivesManagementList:reNew'"
                           v-show="record.status== projectStatus.SERVICING||record.status== projectStatus.END">
                <a  @click="handleReNew(record)">续保</a>
              </a-menu-item>

              <a-menu-item v-has="'archivesManagementList:addIns'"
                           v-show="record.status== projectStatus.SERVICING">
                <a  @click="handleAddIns(record)">加险种</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          </span>
      </a-table>
    </div>

    <archives-management-modal ref="modalForm" @ok="modalFormOk"></archives-management-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JDate from '@/components/jeecg/JDate'
  import { mapGetters } from 'vuex'
  import ArchivesManagementModal from './modules/ArchivesManagementModal'
  import ProjectStatus from '../ProjectStatus'
  import { postAction } from '../../../api/manage'

  export default {
    name: 'ArchivesManagementList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      JDate,
      ArchivesManagementModal,
    },
    data () {
      return {
        projectStatus:{},
        description: '档案管理列表页面',
        disableMixinCreated: true,
        isorter:{
          column: 'id',
          order: 'asc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目编号',
            className:'column-text',
            dataIndex: 'projNum',
            sorter: true
          },
          {
            title:'项目名称',
            className:"column-text",
            dataIndex: 'projectName',
          },
          {
            title:'状态',
            className:"column-text",
            dataIndex: "statusName",
          },
          {
            title:'客户名称',
            className:"column-text",
            dataIndex: 'customerName'
          },
          {
            title:'项目类型',
            className:"column-text",
            dataIndex: 'typeName'
          },

          {
            title:'创建人',
            className:"column-text",
            dataIndex: 'createByName',
          },
          {
            title:'创建时间',
            className:'column-text',
            dataIndex: 'createTime'
          },
          // {
          //   title:'计划提交时间',
          //   className:'column-text',
          //   dataIndex: 'planApplyTime'
          // },
          // {
          //   title:'计划通过时间',
          //   className:'column-text',
          //   dataIndex: 'planAuditTime'
          // },
          // {
          //   title:'计划申请耗时(天)',
          //   className:'column-money',
          //   dataIndex: 'planTakeDays'
          // },
          {
            title:'立项提交时间',
            className:'column-text',
            dataIndex: 'initiationCommitTime'
          },
          {
            title:'立项通过时间',
            className:'column-text',
            dataIndex: 'initiationAuditTime'
          },
          {
            title:'立项耗时(天)',
            className:'column-money',
            dataIndex: 'initiationTakeDays'
          },
          {
            title:'风险管理提交时间',
            className:'column-text',
            dataIndex: 'riskManageCommitTime'
          },
          {
            title:'风险管理通过时间',
            className:'column-text',
            dataIndex: 'riskManageAuditTime'
          },
          {
            title:'保险采购提交时间',
            className:'column-text',
            dataIndex: 'purchaseResultCommitTime'
          },
          {
            title:'保险采购审核时间',
            className:'column-text',
            dataIndex: 'purchaseResultAuditTime'
          },
          {
            title:'保险合同起始时间',
            className:'column-text',
            dataIndex: 'agreementStartTime'
          },
          {
            title:'保险合同截止时间',
            className:'column-text',
            dataIndex: 'agreementEndTime'
          },
          {
            title:'合同剩余天数',
            className:'column-money',
            dataIndex: 'agreementEndTimeSurplus'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:75,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/project/archives/list",
          exportXlsUrl: "/project/archives/exportXls",
          reNew: "/project/baseInfo/reNew",
          addIns:"/project/riskmanage/addIns",
        },
      }
    },
    created() {
      this.projectStatus = ProjectStatus
    },
    methods: {
      ...mapGetters(["userInfo"]),

      handleReNew(record){
        // 提交
        postAction(this.url.reNew,{projNum: record.projNum}).then(res =>{
          if(res.success){
            this.$message.success("已开启续保流程，请至项目基本信息环节继续。")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      handleAddIns(record){
        // 提交
        const req = `${this.url.addIns}?id=${record.id}`;
        postAction(req).then(res =>{
          if(res.success){
            this.$message.success("已开启加险种流程，请至风险管理环节继续。")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      initDictConfig(){
      },

      onDateChange: function (value, dateString) {
        this.queryParam.createTimeRange = dateString;
      },
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        // 创建日期
        if(param.createTimeRange){
          param.createTimeBegin = param.createTimeRange[0] + ' 00:00:00'
          param.createTimeEnd = param.createTimeRange[1] + ' 23:59:59'
          delete param.createTimeRange
        }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>